import { IXC_REGISTRATION_V1_PROFILE_VERSION_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-registration-v1-profile-version-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcRegistrationV1ProfileVersionStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../../util/entity-status-variants';

interface ProfileVersionStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcRegistrationV1ProfileVersionStatus | undefined;
}

export function ProfileVersionStatusPill({ isPending, status, ...props }: ProfileVersionStatusPillProps) {
  return (
    <Pill isPending={isPending || !status} {...props} variant={getEntityVariant(IXC_REGISTRATION_V1_PROFILE_VERSION_STATE_ENTITY_NAME, status)}>
      <TranslatedText
        defaultValue={status}
        i18nKey={{ namespace: 'ixcRegistrationV1', enumName: 'IxcRegistrationV1ProfileVersionStatus', value: status }}
      />
    </Pill>
  );
}
